import { ReactNode } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../../../ui/common-ui/dialog";
import { cn } from "../../../../utils/utils";
import "../../ManagementDialog.css";
import "../../CloudSightAlerts/components/alerts/AlertDetails.css";
import "../shared/SaasApps.css";

export default function DetailModal({ onClose, icon, chips, title, subtitle, actions, children }: {
    onClose: () => void;
    icon: ReactNode;
    chips?: ReactNode;
    title: ReactNode;
    subtitle?: ReactNode;
    actions?: ReactNode;
    children: ReactNode;
}) {
    return (
        <Dialog open onOpenChange={(open) => !open && onClose()}>
            <DialogContent className="management-dialog cad-dialog saas-detail sm:max-w-5xl">
                <DialogHeader className="management-dialog-header cad-header">
                    <div className="management-dialog-heading">
                        <span className="management-dialog-icon cad-header-icon overflow-hidden" aria-hidden="true">{icon}</span>
                        <div className="min-w-0 flex-1">
                            {chips && <div className="cad-chip-row">{chips}</div>}
                            <DialogTitle className="cad-title truncate">{title}</DialogTitle>
                            {subtitle && <DialogDescription className="cad-subtitle">{subtitle}</DialogDescription>}
                        </div>
                        {actions && <div className="flex-shrink-0 self-center">{actions}</div>}
                    </div>
                </DialogHeader>
                <div className="management-dialog-body cad-body">{children}</div>
            </DialogContent>
        </Dialog>
    );
}

export function DetailChip({ children, tone }: { children: ReactNode; tone?: "type" | "severity" | "muted" }) {
    return (
        <span className="cad-chip" data-tone={tone}>
            {children}
        </span>
    );
}

export function DetailOverview({ children }: { children: ReactNode }) {
    return <div className="cad-overview saas-overview-even">{children}</div>;
}

export function DetailField({ icon, label, value, mono, title }: { icon: ReactNode; label: string; value: ReactNode; mono?: boolean; title?: string }) {
    return (
        <div className="cad-field">
            <span className="cad-field-icon" aria-hidden="true">{icon}</span>
            <div className="min-w-0 flex-1">
                <span className="cad-label">{label}</span>
                <span className={cn("cad-value", mono && "cad-mono")} title={title}>{value}</span>
            </div>
        </div>
    );
}

export function DetailSection({ icon, title, action, children }: { icon: ReactNode; title: string; action?: ReactNode; children: ReactNode }) {
    return (
        <section className="cad-section">
            <div className="saas-section-head">
                <h3 className="cad-section-title">
                    {icon}
                    {title}
                </h3>
                {action}
            </div>
            {children}
        </section>
    );
}

export function DetailPanel({ children, className }: { children: ReactNode; className?: string }) {
    return <div className={cn("saas-detail-panel", className)}>{children}</div>;
}

export function DetailEmpty({ children }: { children: ReactNode }) {
    return <div className="cad-empty">{children}</div>;
}
